<style>
  .panel {
    margin-top: 15px;
  }

  #LayersButton {
    position: absolute;
    top: 0px;
    right: 15px;
    z-index: 51;
    padding: 2px 6px;
    font-size: small;
  }

  #Layers {
    position: absolute;
    top: -15px;
    right: 15px;
    z-index: 50;
    max-height: 99% !important;
    width: 300px;
    overflow-y: auto;
  }

  #Layers .panel {
    border-right: 2px solid #0c9cd8 !important;
    background-color: #dbe2eb;
    border-radius: 0px;
  }

</style>
<div>
  <div class="modal-header">
    <h3>Review Application</h3>
  </div>
  <div class="modal-body">
    <div>
      <div class="panel panel-default">
        <div class="panel-heading">
          Facility
          <!--          todo: fix symbol label
            <img *ngIf="r.meta.symbol.contentType | isImage" [src]="r.result.meta.symbol.url"/>-->
        </div>
        <div class="panel-body">
          <span *ngIf="site_response | async as r">
                    <span *ngFor="let key of ['name', 'streetaddress', 'village', 'location_description']">

                        <b><span [innerHtml]="r.meta.fields[key].label | toTrusted"></span></b>:
                        <app-display-field [value]="r.result[key]"
                                           [type]="r.meta.fields[key].type"
                                           [choices]="r.meta.fields[key].choices"></app-display-field>
                        <br/>
                    </span>
          </span>
          <app-attachments *ngIf="item.attributes" type="siteattachments"
                           [foreignKey]="item.attributes"
                           [disableEditing]="true"></app-attachments>

          <div class="row" style="padding-top:10px;">
            <div class="col-md-12">
              <div *ngIf="!showMap"
                   style="display: flex; justify-content: center; align-items: center; position: relative;
                          top: 250px;
                          z-index: 1000;
                          margin-top: -40px;">
                <i class="fa fa-pulse fa-spinner fa-3x"></i>
              </div>
              <div id="mapDiv" style="height: 500px;">
                <div id="zoomToolbar" class="btn-toolbar" *ngIf="showMap">
                  <div class="btn-group">
                    <button id="zoomIn-button" class="btn btn-primary" (click)="zoomIn()">
                      <span class="fa fa-plus"></span>
                    </button>
                    <button id="zoomOut-button" class="btn btn-primary" (click)="zoomOut()">
                      <i class="fa fa-minus"></i>
                    </button>
                    <button id="lock-button" class="btn btn-primary" (click)="toggleMapLock()"
                            ngbTooltip="Map {{map_locked ? 'locked' : 'unlocked'}} click to {{map_locked ? 'unlock' : 'lock'}}."
                            container="body">
                      <i *ngIf="map_locked" class="fa fa-lock"></i>
                      <i *ngIf="!map_locked" class="fa fa-unlock"></i>
                    </button>
                  </div>
                </div>
                <button id="LayersButton" class="btn btn-primary" placement="'left'"
                        (click)="layersIsCollapsed = !layersIsCollapsed" ngbTooltip="Click to toggle layer menu"
                        container="body">
                  Layers
                </button>
                <div id="Layers" style="height:725px;" [ngbCollapse]="layersIsCollapsed">
                  <div class="panel panel-default" style="text-align: center">
                    <div class="panel-body" style="text-align: left;">
                      <div id="layerList"></div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <ng-template ngFor [ngForOf]="items" let-item>
      <app-summary-panel [searchObject]="item.search_object" [meta]="item.meta">
      </app-summary-panel>
    </ng-template>
    <!--    <div>-->
    <!--      <div *ngFor="let item of contacts" class="panel panel-default">-->
    <!--        <div class="panel-heading">-->
    <!--          {{ item.relationship_type | display:contacts.meta.fields.relationship_type.choices }} Information-->
    <!--        </div>-->
    <!--        <div class="panel-body">-->
    <!--          <div class="col-md-6"-->
    <!--               *ngFor="let key of (item.contact_contact_type === 'individual' ? contacts_display_fields : organization_display_fields)">-->

    <!--            <b><span [innerHtml]="contacts.meta.fields[key].label | to_trusted"></span></b>:-->
    <!--            <display-field value="item[key]"-->
    <!--                           type="contacts.meta.fields[key].type"-->
    <!--                           choices="contacts.meta.fields[key].choices"></display-field>-->
    <!--            <br/>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div>-->
    <!--      <div class="panel panel-default">-->
    <!--        <div class="panel-heading">-->
    <!--          Application-->
    <!--        </div>-->
    <!--        <div class="panel-body">-->
    <!--          <standby-generator-chart item="item" load-chart="loadingPromise"></standby-generator-chart>-->
    <!--          <br/><br/>-->
    <!--          <div class="col-md-6" *ngFor="let key of item.meta.display_fields">-->

    <!--            <b><span [innerHtml]="item.meta.fields[key].label | to_trusted"></span></b>:-->
    <!--            <display-field value="item[key]"-->
    <!--                           type="item.meta.fields[key].type"-->
    <!--                           choices="item.meta.fields[key].choices"></display-field>-->
    <!--            <br/>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div>-->
    <!--      <div *ngFor="let item of generators" class="panel panel-default">-->
    <!--        <div class="panel-heading">-->
    <!--          <span>Generator #{{ $index + 1 }} <img *ngIf="generators.meta.symbol.contentType | isimage"-->
    <!--                                                 [src]="{{ generators.meta.symbol.url }}"/></span>-->
    <!--        </div>-->
    <!--        <div class="panel-body row">-->
    <!--          <div class="col-md-6" *ngFor="let key of get_generator_display_fields(item)">-->

    <!--            <b><span [innerHtml]="generators.meta.fields[key].label | to_trusted"></span></b>:-->
    <!--            <display-field value="item[key]"-->
    <!--                           type="generators.meta.fields[key].type"-->
    <!--                           choices="generators.meta.fields[key].choices"></display-field>-->
    <!--          </div>-->
    <!--          <div class="col-md-12">-->
    <!--            <attachment-inline type="standbygenerator/generators_attachments" foreign-key="{{item.globalid}}"-->
    <!--                               disable-editing="{{true}}"></attachment-inline>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div>-->
    <!--      <div *ngFor="let item of  insignificant_sources" class="panel panel-default">-->
    <!--        <div class="panel-heading">-->
    <!--          <span>Insignificant Source #{{ $index + 1 }}</span>-->
    <!--        </div>-->
    <!--        <div class="panel-body row">-->
    <!--          <div class="col-md-6" *ngFor="let key of applications.meta.fields.insignificant_sources.display_fields">-->
    <!--            <b><span [innerHtml]="insignificant_sources.meta.fields[key].label"></span></b>-->
    <!--            <display-field value="item[key]" type="insignificant_sources.meta.fields[key].type"-->
    <!--                           choices="insignificant_sources.meta.fields[key].choices"></display-field>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!-- todo: fix review inline -->
    <!--    <app-routing-review *ngIf="permit !== undefined && generators !== undefined"-->
    <!--                        [contentType]="generatorsService.meta.fields.permits.meta.content_type"-->
    <!--                    [meta]="review_meta" [foreignKey]="item.globalid" [expandOnLoad]="true"></app-routing-review>-->
  </div>
  <div class="modal-footer">
    <!-- todo: fix buttons-->
    <button *ngIf="item.fee_balance <= 0 && !(item.status !== 'rejected')" class="btn btn-primary center"
            (click)="accept.emit(item)">Accept
    </button>
    <button *ngIf="item.status !== 'accepted' && item.status !== 'rejected'"
            class="btn btn-primary center" (click)="reject.emit(item)">Reject
    </button>
    <button class="btn btn-default" (click)="close()">Close</button>
  </div>
</div>
